<template>
    <div class="p-12 container">
        <h2>{{ addingToOrder ? 'Add Mega Bundle' : 'Edit Mega Bundle' }}</h2>

        <!-- <div class="row">
            <div class="col">
                <img src="/img/banner-bundle-ordering.jpg" height="457" width="1108" class="img-fluid">
            </div>
        </div> -->

        <div class="flex flex-wrap" v-if="config">
            <div class="w-full pb-8 md:w-2/3 md:pr-4">

                <ul class="breadcrumb bg-grey-100 rounded p-4 mb-8">
                    <li class="breadcrumb-item"><router-link to="/order">Order</router-link></li>
                    <template v-if="addingToOrder">
                        <li class="breadcrumb-item active">Mega Bundle</li>
                    </template>
                    <template v-else>
                        <li class="breadcrumb-item"><a href="#" @click.prevent="setItemToEdit(null)">Mega Bundle</a></li>
                        <li class="breadcrumb-item active">Edit</li>
                    </template>
                </ul>

                <h3 class="mb-6">
                    <span class="text-green">Step 1 - </span>
                    <span class="text-blue">Choose a Dedicated Server</span>
                </h3>


                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-4" v-for="(server, index) in config.servers" :key="index">
                        <div class="sau-bundle-card">
                            <div class="ribbon red"><span>SAVE {{ getDiscountPercentage(server.priceWithTax, server.rrpWithTax) }}%</span></div>
                            <input type="radio" :id="server.product_id" name="serverSelected" :value="server.product_id" v-model="bundle.server" @change="updateMb()">
                            <label :for="server.product_id">
                            <div class="sau-server-box">
                            <header>
                                <i class="icon icon-sau-dedicated" aria-hidden="true"></i>
                            </header>
                            <ul>
                                <li class="px-2" v-if="server.informationfields.cpu">
                                    <p class="list-title">{{ server.informationfields.cpu.title }}</p>
                                    <p class="list-desc">{{ server.informationfields.cpu.subtitle }}</p>
                                </li>
                                <li class="px-2" v-if="server.informationfields.memory">
                                    <p class="list-title">{{ server.informationfields.memory.title }}</p>
                                    <p class="list-desc">{{ server.informationfields.memory.subtitle }}</p>
                                </li>
                                <li class="px-2" v-if="server.informationfields.storage">
                                    <p class="list-title">{{ server.informationfields.storage.title }}</p>
                                    <p class="list-desc">{{ server.informationfields.storage.subtitle }}</p>
                                </li>
                            </ul>
                            <div class="price-box">
                                <p class="price">{{ server.priceWithTax | currency }}</p>
                                <p class="pm">Per Month</p>
                                <p class="price-was">Was {{ server.rrpWithTax | currency }} Per Month</p>
                            </div>
                            </div>
                            </label>
                        </div>
                        <p class="text-center t-small">On a 12 month contract</p>
                    </div>
                </div>


                <h3 class="mb-4 mt-12">
                    <span class="text-green">Step 2 - </span>
                    <span class="text-blue">Select your INCLUDED Software Bundle</span>
                </h3>

                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-6" v-for="(option, index) in config.options" :key="option.optionid">
                        <div class="sau-input-card-basic">
                            <input type="radio" :id="option.optionid" :value="option.optionid" name="bundleSelected" v-model="bundle.option" @change="updateMb()" :disabled="disableSoftware">
                            <label :for="option.optionid">
                            <div>
                                <img :src="getBundleImage(index)" class="img-fluid">
                            </div>
                            </label>
                            <p v-if="option.informationfields.software">{{ option.informationfields.software.text }}</p>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <div class="sau-bx p-6">
                            <h5 class="text-center t-blue">All Servers Australia Mega Bundles include...</h5>
                            <div class="row p-6">
                                <div class="col sau-bg p-6">
                                    <h5>Essentials Management Plan</h5>
                                    <p>Servers Australia takes away the headaches of updating, monitoring and restarting critical services for your web server.</p>
                                    <ul class="sau-bullets">
                                        <li>Control Panel Management</li>
                                        <li>Control Panel maintenance and updates</li>
                                        <li>24x7 server monitoring and service restarting</li>
                                        <li>Server Security Hardening</li>
                                        <li>RAID & S.M.A.R.T. Monitoring</li>
                                    </ul>
                                </div>
                                <div class="col p-6">
                                    <ul class="sau-topic-list">
                                        <li>
                                            <h5>Backups</h5>
                                            <p>100GB R1 Soft Backups</p>
                                        </li>
                                        <li>
                                            <h5>Location</h5>
                                            <p>Sydney Data Centre</p>
                                        </li>
                                        <li>
                                            <h5>Software Licences</h5>
                                            <p>Included</p>
                                        </li>
                                        <li>
                                            <h5>Transfer</h5>
                                            <p>5TB data</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <sau-ordering-sidebar :data="data" :order="order" :processing="false"></sau-ordering-sidebar>

        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: Object,
        order: Object,
    },

    data() {
        return {
            config: {
                servers: {},
                options: {}
            },
            bundle: {
                server: null,
                option: null
            },
            servers: {},
            type: 'mega-bundle',
            slug: null,
            ready: false,
            // sidebarWidth: '100%',
            // sidebarHeight: 'auto',
            addingAnItem: false,
            validating: false,
        }
    },

    mounted() {
        this.setUp();
    },

    methods: {

        setUp() {

            this.config.servers = this.data.config.products.megaBundle.servers;
            this.config.options = this.data.config.products.megaBundle.bundles.options;

            // If user is returning to a Mega Bundle Order
            if (this.data.active.megaBundle) {
                // Set up the state to match the order
                this.setItemToEdit(this.order.items.find(
                    item => item.type === this.type && item.slug === this.data.active.megaBundle
                ));
            }

            window.bus.$on('validate-order-item', item => {
                if (item.slug !== this.activeItem.slug) return

                let valid = true;
                this.validating = true;

                window.bus.$emit(
                    valid ? 'order-item-valid' : 'order-item-invalid',
                    item
                );
            });
        },

        setItemToEdit: function (item) {
            // is the item.type check needed ?`
            this.data.active.megaBundle = item && item.type === 'mega-bundle' ? item.slug : false;
            this.bundle.server = item && item.type === 'mega-bundle' && item.package ? item.package.id : null;
            this.bundle.option = item && item.type === 'mega-bundle' && item.option ? item.option.id : null;
        },

        updateMb() {
            // If no server has been selected when the options are chosen default to the first one
            if(!this.bundle.server) {
                this.bundle.server = this.data.config.products.megaBundle.servers.server1.product_id;
            }
            // If no control panel has been selected - select the first option as default
            if(!this.bundle.option) {

                this.bundle.option = this.config.options.cpanel.optionid
            }

            if (this.data.active.megaBundle) {

                window.bus.$emit('order.items.update', this.type, this.data.active.megaBundle, {
                    package_id: this.bundle.server,
                    option_id: this.bundle.option
                });
            } else {
                if (this.addingAnItem) {
                    return;
                }

                this.addingAnItem = true;

                let itemData = {
                    package_id: this.bundle.server,
                    option_id: this.bundle.option
                };

                window.bus.$once('order.items.creating', tempItem => {
                    this.data.active.megaBundle = this.slug = tempItem.slug;
                });

                window.bus.$once('order.items.created', response => {
                    this.addingAnItem = false;
                    this.data.active.megaBundle = this.slug = response.data.slug;
                    window.bus.$emit('order.items.update', this.type, response.data.slug, itemData);
                });

                window.bus.$emit('order.items.create', this.type, {
                    ...itemData,
                });
            }
        },

        getBundleImage(bundle) {
            return `/img/logo-${bundle}.gif`;
        },

        getDiscountPercentage(price, rrp) {
            return 100 - ((price * 100 / rrp) | 0);
        }

    },

    computed: {
        addingToOrder() {
            return ! this.editingOrder;
        },

        editingOrder() {
            return !! this.data.active.megaBundle;
        },

        activeItem() {
            let item = this.order.items.find(
                item => item.type === this.type && item.slug === this.data.active.megaBundle
            );

            this.setItemToEdit(item);

            return item;
        },
        disableSoftware() {
            // Disable software selection until a dedi has been chosen
            return !this.bundle.server ? true : false;
        },
    },

}
</script>
<style lang="scss" scoped>
    .sau-bundle-card .icon-sau-dedicated:before {
        content: "\E003" !important;
    }
    .sau-bundle-card .sau-server-box header i {
        line-height: 1rem;
    }
    .price-box .price {
        font-size: 2rem;
    }
</style>


